// extracted by mini-css-extract-plugin
export default {"truncate":"styles_truncate__fjugz","headerWidth":"styles_headerWidth__9RwD0","textWidth":"styles_textWidth__L4WWg"};